import { render, staticRenderFns } from "./CorporateNumberInput.vue?vue&type=template&id=718e2197&scoped=true"
import script from "./CorporateNumberInput.vue?vue&type=script&lang=js"
export * from "./CorporateNumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e2197",
  null
  
)

export default component.exports